// @flow
import React from 'react';
import { fromNow, resizeImage } from 'lib/common';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import 'moment/locale/ko';
import './BrandCard.scss';

type Props = {
  id: string,
  thumbnail: string,
  username: string,
  title: string,
  body: string,
  date: string,
  brandUrl: string,
  urlSlug: string,
  oneColumn?: boolean,
};

const BrandCard = ({ thumbnail, title, body, brandUrl, urlSlug, oneColumn }: Props) => {
  const link = `/@${brandUrl}`;
  const imgUrl = resizeImage(thumbnail, 250, 250);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  return (
    <div className={cx('BrandCard', { 'one-column': oneColumn, empty: !thumbnail })}>
      {thumbnail && <div className={cx("thumbnail-wrapper")} style={style} />}
      <div className="card-content">
        <div className="content-head">
          <div className="title">
            {title}
          </div>
          <div className="description" style={{ WebkitBoxOrient: 'vertical' }}>
            {body}
          </div>
        </div>
      </div>
    </div>
  );
};

BrandCard.defaultProps = {
  oneColumn: false,
};

export default BrandCard;



// WEBPACK FOOTER //
// ./src/components/common/BrandCard/BrandCard.js